import React from "react";
import { Box } from "@mui/material";

const SaleTag = ({ discount, show = true, bottom = 8, left = 8 }) => {
  if (!show || !discount || Number(discount) <= 0) {
    return null;
  }

  return (
    <Box
      sx={{
        position: "absolute",
        bottom,
        left,
        backgroundColor: "#ef4444",
        color: "#fff",
        px: 0.8,
        py: 0.25,
        borderRadius: "2px",
        fontWeight: 600,
        fontSize: "0.50rem",
        letterSpacing: "0.3px",
        textTransform: "uppercase",
        zIndex: 10,
      }}
    >
      Sale
    </Box>
  );
};

export default SaleTag;
